import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import Modal from "react-modal";
import Dropdowns from "./Dropdowns";
import Searchresult from "./Searchresult";
import { useHistory, useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ramactions } from "../store/index";
import SearchPageHeader from "./SearchPageHeader";
import useCustomquesrystring from "../hooks/use-querystring";
import { useTranslation } from "react-i18next";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

const Searchbykeyword = (props) => {
  const { t } = useTranslation("translation", { keyPrefix: "searchByKeyword" });
  const webLanguage = localStorage.getItem("lang");
  const [keywords, setKeywords] = useState("");
  const [searchresults, setSearchresults] = useState([]);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [displaysearchresult, setDisplaysearchresult] = useState(false);
  const [languagesOfferedDropdown, setLanguagesOfferedDropdown] = useState([]);
  const [targetPopulationDropdown, setTargetPopulationDropdown] = useState([]);
  const [disabilitiesAccessDropdown, setDisabilitiesAccessDropdown] = useState(
    []
  );
  const [feeStructureDropdown, setFeeStructureDropdown] = useState([]);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(location.search);
  //const place = useSelector((index) => index.place);
  const isDisplayresult = useSelector((index) => index.isDisplayresult);
  const keyword = useSelector((index) => index.keyword);
  const customquery = useCustomquesrystring();
  const isApicallneeded = useSelector((index) => index.isApicallneeded);
  const [isClearClick, setIsClearClick] = useState(false);
  const place = useSelector((index) => index.place);
  const reservekeywords = [t("keyword_1"), t("keyword_2"), t("keyword_3")];
  useEffect(async () => {
    if (keyword.length > 0) {
      //console.log("Hiiiii");
      setKeywords(keyword);
      await populateDropdownValues(keyword);
      dispatch(ramactions.updateKeyword(keyword));
      showSearchResult();
    }
  }, []);

  const keywordshaddler = async (e) => {
    if (queryParams.has("resourceType")) {
      queryParams.delete("resourceType");
    }
    if (queryParams.has("languages")) {
      queryParams.delete("languages");
    }
    if (queryParams.has("communities")) {
      queryParams.delete("communities");
    }
    if (queryParams.has("accessibilities")) {
      queryParams.delete("accessibilities");
    }
    if (queryParams.has("costs")) {
      queryParams.delete("costs");
    }
    setKeywords(e.target.value);
    await populateDropdownValues(e.target.value);
  };

  const populateDropdownValues = async (inputkeyword, clear = 2) => {
    if (queryParams.has("keyword")) {
      queryParams.delete("keyword");
    }
    history.replace({
      search: queryParams.toString() + "&keyword=" + inputkeyword,
    });
    let langParams;
    let communitiesParams;
    let accessibilityParams;
    let costParams;
    let resourceTypeParams;

    if (clear === 5) {
      langParams = "any";
      communitiesParams = "any";
      accessibilityParams = "any";
      costParams = "any";
      resourceTypeParams = "hotline,physical";
    } else {
      langParams = customquery.langParams;
      communitiesParams = customquery.communitiesParams;
      accessibilityParams = customquery.accessibilityParams;
      costParams = customquery.costParams;
      resourceTypeParams = customquery.resourceTypeParams;
    }

    //dispatch(ramactions.updateKeyword(inputkeyword));
    if (inputkeyword) {
      try {
        const response = await axios.get(
          process.env.REACT_APP_REACT_APP_API_END_POINT +
            process.env.REACT_APP_GET_DROPDOWN_VALUE_BY_KEYWORD +
            webLanguage +
            "/" +
            inputkeyword +
            "/" +
            resourceTypeParams +
            "/" +
            place.latitude +
            "/" +
            place.longitude +
            "/" +
            langParams +
            "/" +
            communitiesParams +
            "/" +
            accessibilityParams +
            "/" +
            costParams +
            "?code=" +
            process.env.REACT_APP_API_KEY
        );

        /*console.log(
          process.env.REACT_APP_REACT_APP_API_END_POINT +
            process.env.REACT_APP_GET_DROPDOWN_VALUE_BY_KEYWORD +
            webLanguage +
            "/" +
            inputkeyword +
            "/" +
            resourceTypeParams +
            "/" +
            place.latitude +
            "/" +
            place.longitude +
            "/" +
            langParams +
            "/" +
            communitiesParams +
            "/" +
            accessibilityParams +
            "/" +
            costParams +
            "?code=" +
            process.env.REACT_APP_API_KEY
        );*/

        setLanguagesOfferedDropdown(response.data.LanguagesOfferedDropdown);
        setTargetPopulationDropdown(response.data.TargetPopulationDropdown);
        setDisabilitiesAccessDropdown(response.data.DisabilitiesAccessDropdown);
        setFeeStructureDropdown(response.data.FeeStructureDropdown);
      } catch (err) {
        //console.log(err);
        dispatch(ramactions.updateErrormsg(err));
        dispatch(ramactions.updateErrorstatus(1));
      }
    } else {
      setLanguagesOfferedDropdown([]);
      setTargetPopulationDropdown([]);
      setDisabilitiesAccessDropdown([]);
      setFeeStructureDropdown([]);
      //history.replace('&subcategory='+e.target.value);
    }
  };

  // const diplayServices = async () => {
  //   console.log(keywords);
  // }

  const diplayServices = async () => {
    //console.log(keywords);
    dispatch(ramactions.updateKeyword(keywords));
    let isModalWillOpen = false;
    reservekeywords.forEach((item) => {
      //console.log(item);
      //console.log(keywords);
      //console.log(keywords.toLowerCase().trim().indexOf(item) !== -1);
      if (keywords.toLowerCase().trim().indexOf(item) !== -1) {
        isModalWillOpen = true;
      }
    });
    if (!isModalWillOpen) {
      showSearchResult();
    } else {
      setIsOpen(true);
    }
  };

  const handleKeyDown = (event) => {
    //console.log("Anish Ghosh!!");
    if (event.key === "Enter") {
      if (keywords.trim().length > 0) diplayServices();
      //console.log("Anish Ghosh Enter!!");
    }
  };

  const showSearchResult = () => {
    if (isApicallneeded) {
      dispatch(ramactions.updateResourceType(["any"]));
      dispatch(ramactions.updateLanguages(["any"]));
      dispatch(ramactions.updateCommunities(["any"]));
      dispatch(ramactions.updateAccessibility(["any"]));
      dispatch(ramactions.updateCost(["any"]));
      setDisplaysearchresult(true);
      dispatch(ramactions.toogleSeachresultdisplay(true));
      dispatch(ramactions.changePogress(true));
      props.onChangekeyword(true);
      window.scrollTo(0, 0);
    } else {
      dispatch(ramactions.updateApiCall(true));
    }
  };

  const modalopenfn = () => {
    setIsOpen(true);
  };

  const afterOpenModal = () => {
    // references are now sync'd and can be accessed.
    //subtitle.style.color = "#f00";
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const continueSearch = () => {
    setIsOpen(false);
    showSearchResult();
  };

  const dropdownchangehanddler = (clear) => {
    populateDropdownValues(keyword, clear);
  };

  const clearallfilter = () => {
    setIsClearClick(true);
    setTimeout(() => {
      setIsClearClick(false);
    }, 1000);
  };

  return (
    <Fragment>
      {!isDisplayresult && (
        <div className="container">
          <Modal
            isOpen={modalIsOpen}
            onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            contentLabel="Modal"
            className="ram ram-modal"
          >
            <div className="modal-content">
              <div className="modal-header">
                <div className="icon">
                  <span className="btb bt-comment" aria-hidden="true"></span>
                </div>
                <div className="title">
                  <h2>{t("modal_title")}</h2>
                </div>
                <button
                  type="button"
                  className="close continue-search-modal"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                >
                  <span className="btb bt-times" aria-hidden="true"></span>
                </button>
              </div>
              <div className="modal-body">
                <p>{t("modal_description")}</p>
                <div className="btn-inline-group">
                  <a
                    href="sms://686868?&amp;body=CONNECT"
                    className="btn btn-poup sms_button"
                  >
                    <span className="img-icon" aria-hidden="true"></span>
                    {t("modal_textus_btn")}
                  </a>
                  <a href="tel:1-800-668-6868" className="btn btn-poup">
                    <span className="btb bt-phone" aria-hidden="true"></span>
                    {t("modal_callus_btn")}
                  </a>
                </div>
                <p className="text-center small-fnt">
                  <Link
                    onClick={continueSearch}
                    className="continue-search-results"
                    aria-label="Close and continue to search result"
                  >
                    {t("modal_continue_search")}
                  </Link>
                </p>
              </div>
            </div>
          </Modal>
          <div className="row">
            <div className="col-xl-4 offset-xl-4 col-lg-6 offset-lg-3 col-md-8 offset-md-2">
              <div className="form-group animate__animated animate__fadeInUp">
                <label className="label" for="keyword_search">
                  {t("search_by_keyword_label")}
                </label>
                <div className="search_input">
                  <input
                    type="text"
                    name="search_by_keyword"
                    placeholder={t("input_placeholder")}
                    id="keyword_search"
                    className="form-control edit_search_by_keyword search_by_keyword textbox"
                    autocomplete="off"
                    onChange={keywordshaddler}
                    value={keywords}
                    onKeyDown={handleKeyDown}
                  />
                </div>
              </div>

              {keywords.trim().length > 0 && (
                <div className="find__resources animate__animated animate__fadeInUp">
                  <button
                    style={{ float: "left" }}
                    onClick={diplayServices}
                    className="btn btn-large btn-secondary find_search-btn"
                  >
                    {t("submit_button")}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {isDisplayresult && (
        <div className="container-fluid container-fluid--1480">
          <div className="row">
            <div className="col">
              <div className="ram-search-result search_list">
                <SearchPageHeader goBackHome={props.backToHome} />

                <Dropdowns
                  languagesOfferedDropdown={languagesOfferedDropdown}
                  targetPopulationDropdown={targetPopulationDropdown}
                  disabilitiesAccessDropdown={disabilitiesAccessDropdown}
                  feeStructureDropdown={feeStructureDropdown}
                  subCategoryID="7"
                  onDropdownchange={dropdownchangehanddler}
                  isClearClick={isClearClick}
                />
                <Searchresult
                  searchresults={searchresults}
                  clearallfilter={clearallfilter}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default Searchbykeyword;
